module.exports = __webpack_public_path__ + "media/stayarm_en.6c5c6d6e.mp3";